const features = [
  {
    icon: 'ri-bookmark-fill',
    title: '收藏漫画',
    desc: '一键收藏正在追更的连载漫画，建立属于你的专属追更清单，想看的作品一部都不落下。',
    tone: 'bg-primary-100 text-primary-700',
  },
  {
    icon: 'ri-notification-4-fill',
    title: '连载更新提醒',
    desc: '开启更新提醒，新话上线第一时间推送。不错过任何一话，追更永远快人一步。',
    tone: 'bg-accent-100 text-accent-700',
  },
  {
    icon: 'ri-calendar-check-fill',
    title: '追漫日历',
    desc: '以周为单位的追漫日历，清晰标注每部作品的更新日期与时间，安排阅读节奏一目了然。',
    tone: 'bg-secondary-100 text-secondary-800',
  },
  {
    icon: 'ri-save-3-fill',
    title: '进度保存',
    desc: '养肥再看也没关系，自动保存已读进度，跨设备同步，随时从上次读到的地方继续。',
    tone: 'bg-primary-100 text-primary-700',
  },
];

export default function Features() {
  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mx-auto max-w-2xl text-center">
        <span className="text-sm font-semibold tracking-wide text-primary-600">为何选择我们</span>
        <h2 className="mt-3 font-heading text-3xl text-foreground-950 md:text-4xl">
          为漫画迷打造的追更收藏工具
        </h2>
        <p className="mt-4 text-foreground-600">
          从收藏到提醒，从日历到进度，我爱漫画网把追更这件事做到简单又可靠。
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {features.map((f) => (
          <article
            key={f.title}
            className="rounded-2xl border border-background-200/70 bg-background-50 p-6 transition-transform duration-300 hover:-translate-y-1"
          >
            <span className={`flex h-12 w-12 items-center justify-center rounded-xl ${f.tone}`}>
              <i className={`${f.icon} text-2xl`}></i>
            </span>
            <h3 className="mt-5 text-lg font-bold text-foreground-950">{f.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{f.desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}